import React from "react";
import css from "classnames";
import { Link, Match } from "@reach/router";
import { Badge } from "@material-ui/core";
import { useQuery } from "@apollo/client";
import logger from "services/logger";
import { isPropertyFeatureEnabled } from "pages/dashboard/interests";
import { query as applicationsQuery } from "./applications-page/queries";
import styles from "./index.module.css";
import { links } from "./index";

const Navigation: React.FC<{ interestId: string }> = ({ interestId }) => {
  const opts = { variables: { interestId } };
  const { data, error } = useQuery(applicationsQuery, opts);
  const orgLists = data?.interest?.organization?.interestLists || [];
  const features = data?.interest?.interestList.property.features || [];
  const appCount: number = data?.otherInterests?.length || 0;
  const tabLinks = [...links];

  if (error) {
    logger.sendError(error);
    return <div>Error loading navigation</div>;
  }

  if (orgLists.length > 1) {
    tabLinks.push({ name: "Applications", to: "applications" });
  }

  return (
    <div className={styles.navigation}>
      <ul className={css("nav", "nav-tabs", styles.sections)}>
        {tabLinks
          .filter((link) => isPropertyFeatureEnabled(features, link.feature))
          .map((link) => (
            <Match<{ page: string }> key={link.name} path=":page">
              {(matchProps) => {
                // make it active if it's the default route - in this case, activity
                const active =
                  (matchProps.match === null && link.to === "activity") ||
                  (matchProps.match && link.to === matchProps.match.page);
                return (
                  <li role="presentation" className={css({ active })}>
                    <Link to={link.to}>
                      {link.name}{" "}
                      {link.name === "Applications" && (
                        <Badge badgeContent={appCount} color="primary" className={styles.badge} />
                      )}
                    </Link>
                  </li>
                );
              }}
            </Match>
          ))}
      </ul>
    </div>
  );
};

export default Navigation;
